import { createAsyncThunk } from '@reduxjs/toolkit';

import ooeConstants from '../constants';
import { State } from '../reducers';
import { selectLocationNumber } from '../user/selectors';
import { getCateringMenu, getMenuNutrition } from './apis';
import { indexNutritionResponse, mapMenuResponseToMenu } from './utils';

const getDestinationsMenu = async ({ location, destination }: { location: string; destination: string }) => {
  const response = await getCateringMenu({ location, destination });
  return mapMenuResponseToMenu(response);
};

export const getMenus = createAsyncThunk('menu/getMenus', async (_, thunkAPI) => {
  const { getState } = thunkAPI;
  const state = getState() as State;
  const location = selectLocationNumber(state);
  const [delivery, pickup] = await Promise.all([
    getDestinationsMenu({ location, destination: ooeConstants.DELIVERY.toLowerCase() }),
    getDestinationsMenu({ location, destination: ooeConstants.PICKUP.toLowerCase() }),
  ]);
  return { delivery, pickup };
});

export const getNutrition = createAsyncThunk('menu/getNutrition', async (_, thunkAPI) => {
  const { getState } = thunkAPI;
  const state = getState() as State;
  const location = selectLocationNumber(state);
  const response = await getMenuNutrition({ location });
  const nutrition = indexNutritionResponse(response);
  return { nutrition };
});
